import * as React from "react";

export function QLiveDot({
  label = "LIVE",
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <span
      className={["qv3-live", className].filter(Boolean).join(" ")}
      role="status"
      aria-live="polite"
    >
      <span aria-hidden="true" className="qv3-live-dot" />
      <span className="qv3-live-label">{label}</span>
    </span>
  );
}
